module.exports = __webpack_public_path__ + "static/media/details-13-image-2.1bc09f7d.jpg";